var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"tabComponent"},[_c('div',{staticClass:"tab-header-container"},[_c('div',{ref:"tabHeader",staticClass:"tab-header"},[_vm._t("tab-header",function(){return [_vm._v("tab标题")]})],2)]),_c('div',{ref:"tabContent",staticClass:"tab-content"},[_vm._t("tab-content",function(){return [_vm._v("tab内容")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }